import Chip from '@mui/material/Chip';

interface Props {
  isInternal: any;
}

export default function BadgeIsInternal({ isInternal }: Props) {
  switch (isInternal) {
    case true:
      return (
        <Chip label="Yes" color="primary" size="small" variant="outlined" />
      );
    case false:
      return <Chip label="No" variant="outlined" size="small" />;
    default:
      return <></>;
  }
}
